import _slicedToArray from "/var/www/main/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import throttle from 'lodash/fp/throttle';
export default (function (_ref) {
  var _ref$activeSectionDef = _ref.activeSectionDefault,
      activeSectionDefault = _ref$activeSectionDef === void 0 ? 0 : _ref$activeSectionDef,
      _ref$offsetPx = _ref.offsetPx,
      offsetPx = _ref$offsetPx === void 0 ? 0 : _ref$offsetPx,
      _ref$sectionElementRe = _ref.sectionElementRefs,
      sectionElementRefs = _ref$sectionElementRe === void 0 ? [] : _ref$sectionElementRe,
      _ref$throttleMs = _ref.throttleMs,
      throttleMs = _ref$throttleMs === void 0 ? 100 : _ref$throttleMs;

  var _useState = useState(activeSectionDefault),
      _useState2 = _slicedToArray(_useState, 2),
      activeSection = _useState2[0],
      setActiveSection = _useState2[1];

  var handle = throttle(throttleMs, function () {
    var currentSectionId = activeSection;

    for (var i = 0; i < sectionElementRefs.length; i++) {
      var section = sectionElementRefs[i].current; // Needs to be a valid DOM Element

      if (!section || !(section instanceof Element)) continue; // GetBoundingClientRect returns values relative to viewport

      if (section.getBoundingClientRect().top + offsetPx < 0) {
        currentSectionId = i;
        continue;
      } // No need to continue loop, if last element has been detected


      break;
    }

    setActiveSection(currentSectionId);
  });
  useEffect(function () {
    window.addEventListener('scroll', handle); // Run initially

    handle();
    return function () {
      window.removeEventListener('scroll', handle);
    };
  }, [sectionElementRefs, offsetPx]);
  return activeSection;
});